import type { MetricsResponse } from "@shared/types";
import { TileCard } from "./TileCard";
import { formatInteger, formatPercent } from "@/lib/format";

interface ConsultsTileProps {
  consults: MetricsResponse["consults"];
}

export function ConsultsTile({ consults }: ConsultsTileProps) {
  const { thisMonth, conversionPct } = consults;

  return (
    <TileCard label="Consults booked" testId="tile-consults">
      <div className="tile-number" data-testid="consults-month">
        {formatInteger(thisMonth)}
      </div>
      <div className="tile-subline">
        Conversion from leads:{" "}
        <strong data-testid="consults-conversion">
          {formatPercent(conversionPct)}
        </strong>
      </div>
    </TileCard>
  );
}
